import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { AppContext } from '../../../sporttia/AppContext';
import { SttForm } from '../../../sporttia/SttForm';
import {
    lockFormElements,
    useCanModifyConfiguration,
} from './useCanModifyConfiguration';

type Customer = {
    id?: number;
    created?: string;
    trash?: boolean;
    subscription?: unknown;
    scs?: unknown;
    numInvoiceFormat?: string;
    iban?: string;
    bic?: string;
    idCreditor?: string;
};

type CustomerResponse = {
    customer: Customer;
};

export default function ConfigurationBilling(): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const canModify = useCanModifyConfiguration();
    const [customer, setCustomer] = useState<Customer>({});

    useEffect(() => {
        loadCustomer();
    }, []);

    /**
     * Load customer
     */
    const loadCustomer = (): void => {
        cxt?.api('GET', `/customers/${cxt.sc?.customer?.id}`, {
            success: (r: CustomerResponse) => {
                delete r.customer.id;
                delete r.customer.created;
                delete r.customer.trash;
                delete r.customer.subscription;
                setCustomer(r.customer);
            },
        });
    };

    const saveCustomer = (): void => {
        const customerToSave = { ...customer };
        delete customerToSave.scs;
        delete customerToSave.id;
        delete customerToSave.created;
        delete customerToSave.trash;
        cxt?.api('PUT', `/backoffice/customers/${cxt.sc?.customer?.id}`, {
            params: customerToSave,
            success: (r: CustomerResponse) => {
                setCustomer(r.customer);
                cxt.showMessage('S', t('Saved'));
            },
        });
    };

    return (
        <Box>
            <SttForm
                onChangeForm={({ name, value }) => {
                    if (!name) return;
                    setCustomer({ ...customer, [name]: value });
                }}
                elements={lockFormElements(
                    [
                        {
                            md: 6,
                            sm: 6,
                            xs: 6,
                            caption: t('NumInvoice'),
                            name: 'numInvoiceFormat',
                            value: customer.numInvoiceFormat,
                        },
                        {
                            md: 6,
                            sm: 6,
                            xs: 6,
                            caption: 'IBAN',
                            name: 'iban',
                            value: customer.iban,
                            disabled: true,
                        },
                        {
                            md: 6,
                            sm: 6,
                            xs: 6,
                            caption: 'BIC',
                            name: 'bic',
                            value: customer.bic,
                        },
                        {
                            md: 6,
                            sm: 6,
                            xs: 6,
                            caption: t('CreditorID'),
                            name: 'idCreditor',
                            value: customer.idCreditor,
                        },
                    ],
                    !canModify,
                )}
                buttons={
                    canModify
                        ? [
                              {
                                  type: 'save',
                                  onClick: () => saveCustomer(),
                              },
                          ]
                        : []
                }
            />
        </Box>
    );
}
